// extracted by css-extract-rspack-plugin
export default {"resetZoomButton":"oqlSmycbzPEfcugv"};